/** True only when signup was started in the native app. */
export function registrationOpensNativeApp(device) {
  return device === "mobile";
}

/** Opens the installed IzzyAI app. Call only after a user tap, and only for app signups. */
export function openIzzyApp() {
  window.location.href = "izzyai://signin";
}
